import { render, staticRenderFns } from "./CollectLedger.vue?vue&type=template&id=2a1d9d65&"
import script from "./CollectLedger.vue?vue&type=script&lang=js&"
export * from "./CollectLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports